import * as React from 'react';
import {
    Typography, Collapse, Stack, Divider, Card, IconButton, Grid,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Popover, Link, Box, CardActionArea, useTheme
} from '@mui/material'

import InfoIcon from '@mui/icons-material/Info';
import {WinIcon, LoseIcon, WinIconInvalid, LoseIconInvalid, EmptyIcon} from 'assets/Icons';
import PercentageCard from './PercentageCard';
import CircuitLogo from 'components/CircuitLogo';
import {prev_rank, next_rank, fetchData, shortenUsername} from 'assets/utils';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { FixMeButton } from './FixMe';

import { styled } from '@mui/material/styles';
import Donut from 'components/Donut';
import { useNavigate } from 'react-router-dom';
import SeriesIcon from 'components/SeriesIcon';
import PointsIcon from 'components/PointsIcon';
import ParticipantsIcon from 'components/ParticipantsIcon';
import { CircuitPredictionCard } from './CircuitPredictionCard';
import StatisticCircle from 'components/StatisticCircle';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { PredictionCard } from './UserCard';
import DisclaimerBox from 'components/DisclaimerBox';
import InfoBox from 'components/InfoBox';
import ShadowBox from 'components/ShadowBox';
import OutlinedBox from 'components/OutlinedBox';
import { useTranslation, Trans } from "react-i18next";

const round2 = (el) => {return Math.round(el*100)/100};

const LBL = {fontWeight: "bold", color: "primary.dark", display: "inline-block", width: 170};
const NUM = {width: 30, textAlign: "left", fontWeight: "bold", color: "primary.dark"};

export default ({is_single, data, handleFix}) => {

    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const circuits = Object.keys(data["padel"]["ratios"]);
    const notes = [];

    var ii = 0;

    for (var i = 0; i < data["padel"]["notes"].length; i++) {
      const note = data["padel"]["notes"][i];
      if (note["type"] == "ratio1") {
        notes.push(<React.Fragment key={note["c1"]}> {ii > 0 ? <Divider/> : null} <Typography sx={{ p: 2 }} component="div" variant="body2"><Trans i18nKey="calculation.note1" components={{
          c1: <SeriesIcon prefix="P" circuit={note["c1"]} style={{transform: 'translateY(5px)'}}/>,
          c2: <SeriesIcon prefix="P" circuit={note["c2"]} style={{transform: 'translateY(5px)'}}/>
        }} /></Typography></React.Fragment>)
        ii += 1;
      } else if (note["type"] == "ratio2") {
        notes.push(<React.Fragment key={"dalen_2"}> {ii > 0 ? <Divider/> : null} <Typography sx={{ p: 2 }} component="div" variant="body2">{t("calculation.note2")}</Typography></React.Fragment>)
        ii += 1;
      } else if (note["type"] == "ratio3") {
        notes.push(<React.Fragment key={note["c1"]}> {ii > 0 ? <Divider/> : null} <Typography sx={{ p: 2 }} component="div" variant="body2"><Trans i18nKey="calculation.note3" values={{target: note["target"], nm: note["nm"]}} components={{
          b: <b/>,
          c1: <SeriesIcon prefix="P" circuit={note["c1"]} style={{transform: 'translateY(5px)'}} />
        }} /></Typography></React.Fragment>)
        ii += 1;
      }
    }

    /*for (var i = 0; i < circuits.length; i++) {
      const circuit = circuits[i];
      const valid_m = circuit <= cur_rank ? data["padel"]["ratios"][circuit]["nm"] >= 5 : data["padel"]["ratios"][circuit]["nm"] >= 9;
      const valid_r =  circuit <= cur_rank || !(cur_rank in data["padel"]["ratios"]) ? true : (data["padel"]["ratios"][cur_rank]["ratio"] >= 0.6 || data["padel"]["ratios"][cur_rank]["nm"] < 5);

      validDict[circuit] = valid_m && valid_r;
      if (valid_m == false) {
        notes.push(<React.Fragment key={circuit}> {ii > 0 ? <Divider/> : null} <Typography sx={{ p: 2 }} component="div" variant="body2">Je moet minimaal <b>{circuit <= cur_rank ? "5" : "9"}</b> wedstrijden hebben in het niveau <CircuitLogo size={20} circuit={circuit} sx={{mr: 0, transform: 'translateY(-2px)'}} /> voor deze berekening ({ data["padel"]["ratios"][circuit]["nm"]}/{circuit <= cur_rank ? "5" : "9"}).</Typography></React.Fragment>)
        ii += 1;
      } else if (valid_r == false) {
        notes.push(<React.Fragment key={circuit}> {ii > 0 ? <Divider/> : null} <Typography sx={{ p: 2 }} component="div" variant="body2">Je moet minimaal een ratio van 60% hebben in het niveau <CircuitLogo size={20} circuit={cur_rank} sx={{mr: 0, transform: 'translateY(-2px)'}}/> om in het niveau <CircuitLogo size={20} circuit={circuit} sx={{mr: 0, transform: 'translateY(-2px)'}}/> te kunnen stijgen.</Typography></React.Fragment>)
        ii += 1;
      }
      
    }

    const pr = prev_rank(cur_rank, data["gender"] == "V");
    if (validDict[cur_rank] && validDict[pr]  && data["padel"]["ratios"][cur_rank]["ratio"] <= 0.3 && data["padel"]["ratios"][cur_rank]["ratio"] >= 0.2 && data["padel"]["ratios"][pr]["ratio"] <= 0.3) {
      notes.push(<React.Fragment key={"dalen_2"}> {ii > 0 ? <Divider/> : null} <Typography sx={{ p: 2 }} component="div" variant="body2">Je daalt 1 klassement door te laag ratio in eigen en lagere reeks.</Typography></React.Fragment>)
        ii += 1;
    }*/

        const current = data.padel.current_rank;
    const predicted = data.padel.predicted_rank;
    const elo = data.padel.elo_rank;

        const isFemale = data.gender == "V";
        
            const firstMark = prev_rank(Math.min(current, predicted), isFemale);
            const maxRank = Math.max(current, predicted);
            const lastMark = next_rank(maxRank, isFemale);


        const theme = useTheme();

    const circuitSelector = React.useMemo(() => 
      {
        var circuitList = [{label: t("calculation.allCalculations"), value: null}];
        for (var i = 0; i < circuits.length; i++) {
          const circuit = circuits[i];
          circuitList.push({label: "P" + circuit, value: circuit});
        }
        return circuitList;
      }
    , [data, t]);
    const [filterIndex, setFilterIndex] = React.useState(0);

    const isOldCircuitFilter = data.season.substring(3,) < 2026 && data.season !== "DEC2025";
    const circuitFilter = {win: circuitSelector[filterIndex].value, lose: circuitSelector[filterIndex].value, rank: isOldCircuitFilter ? current : null}

    React.useEffect(() => {
      setFilterIndex(0);
    }, [data]);

    const [wp, vp] = React.useMemo(() => {
      let totalWp = 0;
      let totalVp = 0;

      for (const result of data?.padel?.results ?? []) {
        for (const [index, match] of (result?.matches ?? []).entries()) {
          if (isMatchFiltered(match, circuitFilter)) {
            continue;
          }

          const [matchWp = 0, matchVp = 0] =
            result?.score_per_match?.[index] ?? [];

          totalWp += matchWp;
          totalVp += matchVp;
        }
      }

      return [Math.round(100 * totalWp) / 100, Math.round(100 * totalVp) / 100];
    }, [data, circuitFilter]);

    return  <>
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"

      sx={{pt: 4, mb: 2}}
    >
      <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" id="padel">
        {t("calculation.title")}
      </Typography>
      <IconButton aria-label="Example" color="primary" onClick={handleClickOpen}>
      <InfoIcon/>
      </IconButton>
    </Stack>

      <PredictionCard
        rank={current}
        predRank={predicted}
        eloRank={elo}
        firstMark={firstMark}
        lastMark={lastMark}
        rankData={data["padel"]}
        isFemale={data["gender"] == "V"}
      />
      
      
      {/*circuits.map((circuit,index) => <WinRatioLine key={circuit} is_female={data["gender"] == "V"} circuit={parseInt(circuit)} valid={data["padel"]["ratios"][circuit]["v"] == 1} data={data["padel"]["ratios"][circuit]} />)*/}
      {circuits.map((circuit,index) => <CircuitPredictionCard key={circuit} isFemale={data["gender"] == "V"} circuit={parseInt(circuit)} data={data["padel"]["ratios"][circuit]} currentRank={data["padel"]["current_rank"]} />)}


      {notes.length > 0 ? <Card sx={{mt: 1, borderRadius: 2, border: '1px solid', borderColor: "divider"}} elevation={0}>
            {notes.map(note => note)}
    </Card> : null}

    {circuits.filter(circuit => data["padel"]["ratios"][circuit]["nm_stat"] > 0).length > 0 ?
    <ShadowBox sx={{display: "flex", flexDirection: "row", alignItems: "space-between", justifyContent: "space-around", flexWrap: "wrap", marginTop: 1}}>
      {/*circuits.filter(circuit => data["padel"]["ratios"][circuit]["nm_stat"] > 0).map(circuit => 
        <div key={circuit} style={{display: "flex", alignContent: "center", justifyContent: "center", paddingTop: 10, width: "50%", minWidth: 200}}>
          <Donut won={data["padel"]["ratios"][circuit]["nw_stat"]} lost={data["padel"]["ratios"][circuit]["nm_stat"] - data["padel"]["ratios"][circuit]["nw_stat"]} name={"P" + circuit}/>
        </div>
        )*/}
        {circuits.filter(circuit => data["padel"]["ratios"][circuit]["nm_stat"] > 0).map(circuit => 
        <div key={circuit} style={{display: "flex", alignContent: "center", justifyContent: "center", width: 160, padding: "10px"}}>
          <StatisticCircle style={{width: "160px"}} left={data["padel"]["ratios"][circuit]["nw_stat"]} right={data["padel"]["ratios"][circuit]["nm_stat"] - data["padel"]["ratios"][circuit]["nw_stat"]} statistic={"P" + circuit}/>
        </div>
        )}
    </ShadowBox> : null}

    <InfoBox title={t("calculation.infoTitle")} color={theme.palette.primary.main} titleColor={theme.palette.primary.dark} backgroundColor="#FCF9FF" >
      <Trans i18nKey="calculation.infoBody" components={{
        b: <b style={{color: theme.palette.primary.dark}} />,
        br: <br/>
      }} />
    </InfoBox>

    <DisclaimerBox/>


    <ShadowBox sx={{mb: 1, mt: 4, overflow: "hidden"}} elevation={0}>

       <Grid sx={{pl: 2, backgroundColor: "primary.main", height: 60}}  container alignItems="center" justifyContent="space-between">
          
            <Stack>
              <Typography variant="body" color="common.white" sx={{fontWeight: "bold"}}>
                {t("calculation.results")}
              </Typography>
              <Typography variant='caption' color="common.white">
                  {data["name"]} (P{data["padel"]["current_rank"]})
                </Typography>
            </Stack>
          
            <FixMeButton handleFix={handleFix}/>
         
        </Grid>
    </ShadowBox>

    {data["padel"]["results"].length > 0 ? <ShadowBox sx={{}}>
       <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <Button
            size="small"
            onClick={() => setFilterIndex(filterIndex - 1)}
            style={{visibility: filterIndex == 0 ? 'hidden' : 'visible'}}
          >
            <KeyboardArrowLeft /> 
          </Button>

        <Typography sx={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", userSelect: 'none', fontSize: 16}} color="primary.main">
            {circuitSelector[filterIndex].label}
        </Typography>

        <Button
            size="small"
            onClick={() => setFilterIndex(filterIndex + 1)}
            //disabled={selected == seasons.length - 1}
            style={{visibility: filterIndex == circuitSelector.length - 1 ? 'hidden' : 'visible'}}
          >
            <KeyboardArrowRight />
          </Button>
        </Box>

        <Box sx={{width: "100%", flexDirection: "row", display: "flex", borderTop: '1px solid', borderColor: "divider", pt: 1, mb: 1}}>
          <Box sx={{width: "50%", display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Typography variant="body2" color="text.secondary">
              {t("calculation.winPoints")}
            </Typography>
            <Typography variant="body" fontWeight="bold" color="primary.light" component="div">
              {wp} WP
            </Typography>
          </Box>
          <Box sx={{width: "50%", display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Typography variant="body2" color="text.secondary">
              {t("calculation.losePoints")}
            </Typography>
            <Typography variant="body" fontWeight="bold" color="primary.dark" component="div">
              {vp} VP
            </Typography>
          </Box>
        </Box>
    </ShadowBox> : null}

        {data["padel"]["results"].length == 0 ? <OutlinedBox>
          <Typography variant='body2' component="div" sx={{padding: 1, fontStyle: "italic", textAlign: "center", color: "text.secondary"}}>{t("calculation.noResults")}</Typography></OutlinedBox> : null}

        {data["padel"]["results"].map((el, index) => <ResultLine key={el["title"] + el["subtitle"] + el["score"] + el["series"]} data={el} index={index} circuitFilter={circuitFilter} />)}

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{t("calculation.dialogTitle")}</DialogTitle>
            <DialogContent>

            <DialogContentText>
            <Trans i18nKey="calculation.dialogBody" components={{
              link: <Link underline="none" sx={{fontWeight: "bold"}} href="https://www.tennisenpadelvlaanderen.be/padel/klassementen-berekening" color="primary" />
            }} />
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>{t("common.close")}</Button>
            </DialogActions>
        </Dialog>    

    <InfoBox title={t("calculation.pointsTitle")} color={theme.palette.primary.main} titleColor={theme.palette.primary.dark} backgroundColor="#FCF9FF">
          {t("calculation.pointsIntro")} <br/>

          <Typography variant="caption" sx={{...LBL, mt: '4px'}}>{t("calculation.roundPoule")}</Typography>
          <b style={{color: theme.palette.text.primary}}>{t("common.wp")}</b> <Typography variant="caption" display="inline-block" sx={NUM} component="div">1</Typography>
          <b style={{color: theme.palette.text.primary}}>{t("common.vp")}</b> <Typography variant="caption" display="inline-block" sx={NUM} component="div">1</Typography><br/>
          <Typography variant="caption" sx={LBL}>{t("calculation.roundTable")}</Typography>
          <b style={{color: theme.palette.text.primary}}>{t("common.wp")}</b> <Typography variant="caption" display="inline-block" sx={NUM} component="div">1.5</Typography>
          <b style={{color: theme.palette.text.primary}}>{t("common.vp")}</b> <Typography variant="caption" display="inline-block" sx={NUM} component="div">0.5</Typography>

          <span style={{height: "8px", display: "block"}}/>
          {t("calculation.categoryIntro")} <br/>
          <Typography variant='caption' sx={{...LBL, mt: '4px'}}>{t("calculation.catMenWomen")}</Typography>{t("calculation.percentOfPoints", {percent: 100})}<br/>
          <Typography variant='caption' sx={LBL}>{t("calculation.catInterclub")}</Typography>{t("calculation.percentOfPoints", {percent: 80})}<br/>
          <Typography variant='caption' sx={LBL}>{t("calculation.catMixedMan")}</Typography>{t("calculation.percentOfPoints", {percent: 40})}<br/>
          <Typography variant='caption' sx={LBL}>{t("calculation.catMixedWoman")}</Typography>{t("calculation.percentOfPoints", {percent: 100})}<br/>
          <Typography variant='caption' sx={LBL}>{t("calculation.catLegends")}</Typography>{t("calculation.percentOfPoints", {percent: 40})}<br/>

          <span style={{height: "8px", display: "block"}}/>
          <Trans i18nKey="calculation.womenInMenSeries" components={{
            link: <Link underline="none" sx={{fontWeight: "bold"}} href="https://www.tennisenpadelvlaanderen.be/padel/klassementen-berekening" color="primary" />
          }} />
          {" "}
          <Trans i18nKey="calculation.reductionBody" components={{
            hl: <Typography variant="caption" sx={{fontWeight: "bold", color: "primary.dark", display: "inline"}} />
          }} />
    </InfoBox>
    
  </>
}


const CustomButton = styled(Button)({
  width: '100%',
  boxShadow: 'none',
  textTransform: 'none',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#FFFFFF',
    borderColor: '#FFFFFF',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#FFFFFF',
    borderColor: '#FFFFFF',
  },
});

const CustomBox = styled(Box)({
  border: "1px solid lightgray",
  borderRadius: 5,
});

const WinLoseIcon = ({type, ...sx}) => {
  if (type == "W") {
    return  <WinIcon {...sx} />;
  } else if (type == "L") {
    return <LoseIcon {...sx} />
  } else if (type == "WI") {
    return  <WinIconInvalid {...sx} />
  } else if (type == "LI") {
    return <LoseIconInvalid {...sx} />
  } else if (type == "|") {
    return <Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 4, marginLeft: 1}}/>
  } else if (type == "G") {
    return <EmptyIcon/>
  }
}

function RoundName({data}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const id = data?.p_id;
  
  const navigateToUser = () => {
      fetchData(id, (content) => {
          navigate("/speler/" + id, {
              state: { ...content, ts: new Date().getTime() },
          });
      });
  };

  const theme = useTheme();

  return <>
    {data["rn"]}
    {data["p_name"] && data["p_name"].length > 0 ? <>
      {" " + t("common.with") + " "}
      <b style={{
            fontWeight: "bold",
            color: theme.palette.primary.main,
            cursor: id ? "pointer" : "default",
            "&:hover": id ? { color: theme.palette.primary.dark } : {},
          }} 
          onClick={id ? navigateToUser : null} color="primary">{shortenUsername(data["p_name"])}</b>
    </> : null}
  </>
}

function SeriesWL({ data, circuitFilter }) {
  const isFilteredValues =
    data.matches?.map(match => isMatchFiltered(match, circuitFilter)) ?? [];

  let matchIndex = 0;

  return data.WL?.map((type, index) => {
    const isMatchResult = type === "W" || type === "L";

    const isFiltered = isMatchResult
      ? isFilteredValues[matchIndex++]
      : false;

    return (
      <WinLoseIcon
        key={`${type}-${index}`}
        type={type}
        opacity={isFiltered ? 0.5 : 1}
      />
    );
  });
}

function ICWL({data, circuitFilter}) {
  const wlByCircuit = React.useMemo(() => {
      return (data.matches ?? []).reduce((result, match) => {
        const circuit = match.circuit;

        if (!result[circuit]) {
          result[circuit] = [];
        }

        let type;

        if (match.did_win === 1) {
          type = match.is_valid === 0 ? "WI" : "W";
        } else {
          type = match.is_valid === 0 ? "LI" : "L";
        }

        result[circuit].push({
          type,
          isFiltered: isMatchFiltered(match, circuitFilter),
        });

        return result;
      }, {});
    }, [data.matches, circuitFilter]);

    return Object.entries(wlByCircuit).map(([circuit, matches]) => (
      <Box key={circuit} style={{display: "flex", alignItems: "center"}} sx={{mt: 0.5}}>
        <CircuitLogo size={20} circuit={circuit} />
        <Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 5}}/> 
        {matches.map((match, index) => (
          <WinLoseIcon key={index} type={match.type} opacity={match.isFiltered ? 0.5 : 1} />
        ))}
      </Box>
    ));
}


const ResultLine = ({data, index, circuitFilter}) => {
  const { t } = useTranslation();

    const [open, setOpen] = React.useState(false);

    const ic = data["IC"] == 1;

    const theme = useTheme()

    const wp = (data.matches?.map((match, index) => isMatchFiltered(match, circuitFilter) ? 0 : data.score_per_match[index][0]) ?? []).reduce((a, b) => a + b, 0);
    const vp = (data.matches?.map((match, index) => isMatchFiltered(match, circuitFilter) ? 0 : data.score_per_match[index][1]) ?? []).reduce((a, b) => a + b, 0);

    return <ShadowBox
          sx={{
            p: 0, 
            mt: 1,
            mb: 1
        }}
        >
        <Stack sx={{width: "100%", alignItems: "flex-start", pt: 1}} >

            <Stack sx={{justifyContent: "space-between", flexDirection: "row", alignItems: "center", width: "100%", px: 1}}>
              <Typography variant="caption" component="div" color="#a0a0a0">
                    {data.participants ? [
                      <ParticipantsIcon participants={data.participants} color="#a0a0a0"/>,
                      <Typography variant="caption" component="span"  color="#a0a0a0" sx={{fontSize: 12, marginRight: "3px", marginLeft: "3px"}}>
                        {"\u2022"}
                      </Typography>
                    ]: null}
                    {data["rn"] ? <RoundName data={data} /> : data["subtitle"]}
                </Typography>
                <Typography variant="caption" component="div" color="#a0a0a0">
                    {data["date"] ? new Date(data["date"]).toLocaleDateString(t("dates.locale"), {day: "numeric", month: "short", year: "2-digit"}) : null}
                </Typography>
            </Stack>

              
              <Typography variant="body2" component="div" sx={{fontWeight: "bold", fontSize: 14, lineHeight: "1em", mb: 1, mt: 0.5, px: 1}} color="text.primary_bold">
                {data.title && data.title.toUpperCase()} {data["format"] == "SMALL" ? <b style={{color: "#999", paddingLeft: "2px"}}>SMALL</b> : null}
              </Typography>

            <Divider width="100%"/>
            
            <Stack 
            onClick={()=>{setOpen(!open)}}
            sx={{
              alignItems: "center",
              justifyContent: "space-between", flexDirection: "row", width: "100%", py: 1, px: 1, 
              '&:hover': {cursor: "pointer"}
              }}>
            <Box sx={{display: "flex", alignItems: ic ? "flex-start" : "center", flexDirection: ic ? "column" : "row"}}>
            
            {!ic ? <>
            {/*<CircuitLogo size={20} sx={{}} circuit={data["circuit"]} />*/}
            <SeriesIcon circuit={data["circuit"]} prefix={data["series"].substring(1,2)}/>

            <Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 5}}/>

            <PointsIcon points={Math.round(100 * wp)/100} isWp/>
            <PointsIcon points={Math.round(100 * vp)/100}/>
            
            {"WL" in data ? <><Divider orientation={"vertical"} flexItem sx={{my: 0.2}} style={{marginRight: 5}}/> <SeriesWL data={data} circuitFilter={circuitFilter}/></> : null}
           
            </> : (
             <ICWL data={data} circuitFilter={circuitFilter} />
            )}

            </Box>

            {open ? <KeyboardArrowUpIcon style={{marginLeft: "2px", color: "#ccc"}}/> : <KeyboardArrowDownIcon style={{marginLeft: "2px", color: "#ccc"}}/>}
            </Stack>

        </Stack>

        <Collapse in={open} sx={{width: "100%"}} unmountOnExit>
           <Box sx={{display: "flex", justifyContent: "center", flexDirection: "column", px: 1}}>
        {"matches" in data ? <MatchResults matches={data["matches"]} scores={data["score_per_match"]} circuitFilter={circuitFilter} /> : null}
        <TableContainer component={CustomBox} sx={{mt: 1, mb: 1}}>
          <Table sx={{p: 0}} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell sx={{p: 1}}></TableCell>
                {data["subscores"].map((el, index) => <TableCell key={el["title"] + index} align="right" sx={{fontWeight: "bold", color: "text.primary_bold"}}>{el["title"]}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              
                <TableRow
                  key="1"
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell sx={{p: 1, fontWeight: "bold", color: "text.primary_bold"}}>
                    WP
                  </TableCell>
                  {data["subscores"].map((el, index) => <TableCell key={el["title"]} align="right" sx={{fontWeight: "bold", color: (theme) => theme.palette.primary.main}}>{el["sl"] !== undefined ? el["sl"][0] : el["score"][0]}</TableCell>)}
                </TableRow>
                <TableRow
                  key="2"
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell  sx={{p: 1, fontWeight: "bold", color: "text.primary_bold"}}>
                    VP
                  </TableCell>
                  {data["subscores"].map((el, index) => <TableCell key={el["title"]} align="right" sx={{fontWeight: "bold", color: (theme) => theme.palette.primary.main}}>{el["sl"] !== undefined ? el["sl"][1] : el["score"][1]}</TableCell>)}
                </TableRow>
              
            </TableBody>
          </Table>
          </TableContainer>

          {data["url"] ? <Button sx={{display: "flex", alignSelf: "center", mb: 1, mt: -1}} onClick={() => window.open(data["url"])}>{t("calculation.toTable")}</Button> : null}
          </Box>
        </Collapse>

        </ShadowBox>
}

const CategoryLine = ({index, data, circuit}) => ( <>

  {index > 0 ? <Divider/> : null}

  <Box sx={{position: "relative", alignItems: 'center', pl: 2, py: 1, display: 'flex', flexDirection: "row", justifyContent: "space-between"}}>
    <CircuitLogo size={40} circuit={circuit} />
    <Box sx={{display: "flex", alignItems: "flex-end", flexDirection: "column"}}>
      <Typography sx={{fontWeight: "bold", color: "text.primary_bold"}}>
        WP <Typography display="inline-block" sx={{width: 50, textAlign: "left", fontWeight: "bold", color: "primary.main"}} component = "div">{Math.round(100 * data["wp"])/100}</Typography>
      </Typography>
      <Typography sx={{fontWeight: "bold", color: "text.primary_bold"}}>
        VP <Typography display="inline-block" sx={{width: 50, textAlign: "left", fontWeight: "bold", color: "primary.main"}} component = "div">{Math.round(100 * data["vp"])/100}</Typography>
      </Typography>
      <Typography sx={{fontWeight: "bold", color: "text.primary_bold"}}>
        R <Typography display="inline-block" sx={{width: 50, textAlign: "left", fontWeight: "bold", color: "primary.main"}} component = "div">{Math.round(100*data["ratio"])}%</Typography>
      </Typography>
    </Box>
  </Box>

  </>
)

export const WinRatioLine = ({circuit, data, is_female, valid}) => {
    const { t } = useTranslation();
  const height = 40;
  const tagHeight = 26;

  const ratio = data["ratio"]
  const mi = data["mi"]
  const ma = data["ma"]
  const wp = data["wp"]
  const vp = data["vp"]

  const [open, setOpen] = React.useState(false);

  return <CardActionArea onClick={()=>{setOpen(!open)}} disableRipple><Box sx={{display: 'flex', flexDirection: "column", position: "relative", mt: 3, opacity: valid ? 1 : 0.4}} style={{marginBottom: "40px"}}>
      <Box sx={{overflow: "hidden", borderBottomRightRadius: 5, borderTopLeftRadius: 5, borderTopRightRadius: 5, border: (theme) => '2px solid ' + theme.palette.primary.main, backgroundColor: "primary.light"}}>
      <Box sx={{display: 'flex', flexDirection: "row", height: height, position: "relative", width: "100%"}}>
          <Box sx={{backgroundColor:"#d5a5fa", flex: ratio}}>
              
          </Box>
          <Box sx={{backgroundColor: '#ead4fa', opacity: 1, flex: 1-ratio}}>
              
          </Box>
      </Box>
      
      <Collapse in={open}>
      <Box sx={{color: "white", backgroundColor: "primary.main", px: 1.5, py: 1}}>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 110, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>{t("calculation.numberOfMatches")}</Typography> {data["nm"]}
        </Typography>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 20, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>WP</Typography> {round2(data["wp"])} = {data["wpb"].map((el, index) => index > 0 ? (el >= 0 ? " + " : " - ") + round2(Math.abs(el)) : round2(Math.abs(el)))}
        </Typography>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 20, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>VP</Typography> {round2(data["vp"])} = {data["vpb"].map((el, index) => index > 0 ? (el >= 0 ? " + " : " - ") + round2(Math.abs(el)) : round2(Math.abs(el)))}
        </Typography>
        
      </Box>
      </Collapse>
      </Box>
      
      {prev_rank(circuit, is_female) == circuit ? null : <InfoTag fraction={mi} height={height} tag={"P" + circuit} reached={ratio > mi}/>}
      {next_rank(circuit, is_female) == circuit ? null : <InfoTag fraction={ma} height={height} tag={"P" + next_rank(circuit, is_female)} reached={ratio > ma}/>}

      

      <Typography component="div" sx={{fontWeight: "bold", fontSize: 12, position: "absolute", left: 0, bottom: 0, height: tagHeight, borderBottomRightRadius: 5, borderBottomLeftRadius: 5, lineHeight: tagHeight + 'px', pr: 1, pl: 1, display: "flex", alignItems: "center", backgroundColor: "primary.main"}} style={{marginBottom: '-' + (tagHeight-2) + 'px'}} >
      <CircuitLogo size={20} circuit={circuit} sx={{mr: 1}} /> {Math.round(100*wp)/100} &frasl; {Math.round(100*(vp+wp))/100} = {Math.round(1000*ratio)/10}%
      <InfoIcon sx={{color: "white", fontSize: 18, ml: 0.5, opacity: 0.8}}/>
      </Typography>
  </Box>
  </CardActionArea>
}

const InfoTag = ({fraction, height, tag, reached}) => {

  const tagColor = 'primary.main'//"rgba(160, 10, 247, " + f + ")"

  const tagHeight = 16;
  const padding = -1;

  const ml = 'calc(2px + ' + fraction + ' * (100% - 4px))';

  return <Box sx={{display: "flex", alignItems: "center", flexDirection: "column", transform: 'translate(-50%,-' + (tagHeight + padding) + 'px)', height: height + tagHeight + padding, position: "absolute", ml: ml}}>
      <Box sx={{height: tagHeight, px: 0.5, backgroundColor: tagColor, textAlign: "center", lineHeight: tagHeight + 'px', pt: 0.2, fontSize: 9, borderTopLeftRadius: 5, borderTopRightRadius: 5, fontWeight: "bold"}}>
      {Math.round(100*fraction)}% {tag}
      </Box>
      <Box sx={{width: 0, border: (theme) => "0.5px solid " + theme.palette.primary.main, marginTop: '0px', marginBottom: '-2px', height: height + 2, backgroundColor: 'primary.main'}}/>
  </Box>
}


const MatchResults = ({matches, scores, circuitFilter}) => {
  return <CustomBox sx={{mt: 2}}>
    {matches.map((el, index) => <MatchResult key={index + el.round} match={el} wp={scores[index][0]} vp={scores[index][1]} circuitFilter={circuitFilter} />)} 
  </CustomBox>

}

function isMatchFiltered(match, circuitFilter) {
  return (match["did_win"] == 1 && circuitFilter.win != null && (match["circuit"] < circuitFilter.win || (circuitFilter.win < circuitFilter.rank && match["circuit"] >= circuitFilter.rank))) || (match["did_win"] == 0 && circuitFilter.lose != null && (match["circuit"] > circuitFilter.lose || (circuitFilter.lose > circuitFilter.rank && match["circuit"] <= circuitFilter.rank)));
}

const MatchResult = ({match, wp, vp, circuitFilter}) => {
    const theme = useTheme();

    const navigate = useNavigate();

    const num_opponents = match["opponents"].length

    const isFiltered = isMatchFiltered(match, circuitFilter);
    const wpTrue = isFiltered ? 0 : wp;
    const vpTrue = isFiltered ? 0 : vp;

    return <Box p={1} display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: "1px solid lightgray" ,'&:last-child': { borderBottom: 0 } }}>
    <Box display="flex" flexDirection="column" sx={{opacity: isFiltered ? 0.5 : 1}}>
    {match["opponents"].map(opponent => <Typography key={opponent["player_id"]} variant="caption" fontWeight="bold" color="primary.main" sx={{cursor: "pointer", lineHeight: 1.5}} onClick={() => navigate('/speler/' + opponent.player_id)}>
      {shortenUsername(opponent["name"])}{num_opponents > 1 ? <b style={{color: theme.palette.text.secondary}}>&nbsp;&nbsp;P{opponent.rank}</b> : null}
    </Typography>)}
    
      <Typography variant="caption" color="text.secondary" lineHeight={1.4}>
        <b>{match["did_win"] == 1 ? wpTrue : vpTrue} {match["did_win"] == 1 ? 'WP' : 'VP'}</b>{match.circuit ? ' • P' + match.circuit  : ''} • {match.round}
      </Typography>
    </Box>
    <Box display="flex" alignItems="center" flexDirection="row" justifyContent="center" sx={{opacity: isFiltered ? 0.5 : 1}}>
      <Typography variant="caption" color="text.secondary" fontWeight="bold" px={1} pt='1px'>
        {match.score}
      </Typography>
      {match["did_win"] == 1 ? (match["is_valid"] == 0 ? <WinIconInvalid/> : <WinIcon/>) : (match["is_valid"] == 0 ? <LoseIconInvalid/> : <LoseIcon/>)}
    </Box>
  </Box>
}